// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
import type {
  IGetUserRecommendationsRequest,
  TGetUserRecommendationsModel,
  IMappers,
  TGetUserRecommendationsResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IV1GetUserRecommendationsResponse1 } from '../../entities/get_user_recommendations/V1GetUserRecommendationsResponse1';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetUserRecommendationsModel(
  parameters: IGetUserRecommendationsRequest,
): TGetUserRecommendationsModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'newbuilding-search',
    pathApi: '/v1/get-user-recommendations/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetUserRecommendationsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetUserRecommendationsRequest;
}

export async function fetchGetUserRecommendations<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetUserRecommendationsOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetUserRecommendationsResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetUserRecommendationsModel(parameters),
    config,
  )) as FetchResponse<TGetUserRecommendationsResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IV1GetUserRecommendationsResponse1, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }

  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetUserRecommendationsResponse>;
}
